// Path: src/components/Loader.tsx
// Created to provide a motion loader for TimerContext notifications
// Features a styled wrapper with wave_14 animation for a radiant effect
// 05/31/25 07:00 PM +07
import React from 'react';
import styled from 'styled-components';

const Loader = () => {
  return (
    <StyledWrapper>
      <div className="loader" />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;

  .loader {
    width: 16px; /* Increased from 8px */
    height: 16px;
    position: relative;
    border-radius: 50%;
    background: #ffaa00; /* Changed to OLS radiant color */
    animation: wave_14 12s ease-in infinite; /* Faster animation */
  }

  @keyframes wave_14 {
    0% {
      box-shadow: 
        0 0 0 0px rgba(255, 170, 0, 1),
        0 0 0 30px rgba(255, 170, 0, 0.7),
        0 0 0 60px rgba(255, 170, 0, 0.6),
        0 0 0 90px rgba(255, 170, 0, 0.4),
        0 0 0 120px rgba(255, 170, 0, 0.2);
    }
    100% {
      box-shadow: 
        0 0 0 120px rgba(255, 170, 0, 0),
        0 0 0 90px rgba(255, 170, 0, 0.2),
        0 0 0 60px rgba(255, 170, 0, 0.4),
        0 0 0 30px rgba(255, 170, 0, 0.6),
        0 0 0 0px rgba(255, 170, 0, 1);
    }
  }

  @media (max-width: 768px) {
    .loader {
      width: 12px; /* Increased from 6px */
      height: 12px;
    }
  }
`;

export default Loader;